import * as R from "ramda";
import * as React from "react";
import { FaPencilAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { courseAssessmentViews, fullCourseViews } from "../../../utils/courseViews";
import { ComponentLinkDiv } from "../../pages/CourseAuthor/CourseNavigation/ComponentLink";
import { ClickableMenuItem } from "../../utils/ClickableElement";
import { findComponent } from "../helpers/patches/util";
import { CourseUnitView, ICourseNavigationOperations, IFullCourse, Slide } from "../types";

interface IAssessmentLinkProps {
  course: IFullCourse;
  displayedComponent: Slide | null;
  navigationOperations: ICourseNavigationOperations;
  unitPath: CourseUnitView[];
  rootUrl: string;
}

const AssessmentComponentLinkDiv = styled(ComponentLinkDiv)`
  flex-wrap: wrap;
  width: 100%;
  min-height: 3rem;
  align-items: center;
  overflow: hidden;
  svg {
    margin: 0rem 0.8rem;
    height: 1.8rem;
    width: 2rem;
  }
`;

export const AssessmentLink: React.SFC<IAssessmentLinkProps> = ({
  course,
  unitPath,
  navigationOperations: { setDisplayedComponent },
  displayedComponent,
  rootUrl,
}: IAssessmentLinkProps) => {
  if (!displayedComponent) {
    return null;
  }
  const test = fullCourseViews.assessment(course, unitPath);

  if (R.isNil(test)) {
    return null;
  }

  const questions = (courseAssessmentViews.questions(test) || []).filter(q => !q.deleted);
  return (
    <AssessmentComponentLinkDiv data-selected={displayedComponent === test}>
      <Link to={`${rootUrl}?position=${findComponent(course, unitPath)}.test`} onClick={setDisplayedComponent(test)}>
        <ClickableMenuItem>
          <FaPencilAlt />
          Assessment ({questions.length})
        </ClickableMenuItem>
      </Link>
    </AssessmentComponentLinkDiv>
  );
};
